import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Reset scroll to top on forward navigation.
 *
 * React Router's BrowserRouter has no built-in scroll restoration, so the SPA
 * keeps the previous page's scroll on a route change, landing the viewer mid or
 * bottom of the new page. This resets it (instant, not smooth) on PUSH/REPLACE,
 * and leaves POP (browser back/forward) to the browser's own scroll
 * restoration. The shop is window-scrolled (no overflow container), so
 * window.scrollTo is the right target. Renders nothing.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    if (navType !== 'POP') window.scrollTo(0, 0);
  }, [pathname, navType]);
  return null;
}
